





































import { Component, Vue } from 'vue-property-decorator';
import text from '@/data/text';

@Component
export default class Su extends Vue {
  text = text.su;
}
